// extracted by mini-css-extract-plugin
export var aEmpty = "Ya";
export var aTitle = "Za";
export var pNewsList = "_a";
export var aInner = "ab";
export var aDate = "bb";
export var aCategory = "cb";
export var aButton1 = "db";
export var aButton2 = "eb";
export var aButton3 = "fb";
export var aButton4 = "gb";
export var aButton5 = "hb";
export var aButtonHeaderLogin = "ib";
export var aButtonHeaderRegister = "jb";
export var aButtonBig = "kb";
export var aButtonRegister = "lb";
export var aButtonLogin = "mb";
export var aButtonContinuation = "nb";
export var icon = "ob";
export var aButtonHeaderSpLogin = "pb";
export var aArrow1 = "qb";
export var aArrow2 = "rb";
export var aText = "sb";
export var animationMarquee = "tb";